var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCohortNavigationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#5767DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2222 17.5L27.2222 12.5M27.2222 12.5L22.2222 12.5M27.2222 12.5L18.0555 21.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.168H16.5C14.2909 14.168 12.5 15.9588 12.5 18.168V23.5013C12.5 25.7104 14.2909 27.5013 16.5 27.5013H21.8333C24.0425 27.5013 25.8333 25.7104 25.8333 23.5013V20.0013",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCohortNavigationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cohort-navigation-icon.10da44432bd823520645a2dcdfb44687.svg";